import React from 'react';

import { Box, Chip, Typography, alpha } from '@mui/material';

import { departureActionDefinitions } from './departureActions';
import { actionColour, actionText } from './palette';

export default function ActionDefinitions() {
  return (
    <Box
      aria-label="Action definitions"
      sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(2, minmax(0, 1fr))' }, gap: 1, my: 2 }}
    >
      <Typography variant="caption" fontWeight={700} sx={{ gridColumn: '1 / -1' }}>
        All actions and counts are per departure.
      </Typography>
      {departureActionDefinitions
        .filter(({ flag }) => ['red', 'amber', 'green', 'empty', 'early', 'handed back'].includes(flag))
        .map(({ flag, label, description }) => (
          <Typography key={label} variant="caption">
            <Chip
              data-definition-pill
              size="small"
              label={label}
              sx={{
                color: actionText(flag),
                bgcolor: alpha(actionColour(flag), 0.14),
                fontSize: 11,
                fontWeight: 700,
                mr: 0.5,
                mb: 0.5,
              }}
            />{' '}
            {description}
          </Typography>
        ))}
    </Box>
  );
}
